import { LockOutlined } from "@mui/icons-material";
import { Typography, Avatar, Grid2, Box, TextField } from "@mui/material";
import { FC } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useApi } from "../../api/use-api";
import { signIn } from "../../api/auth/auth";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/button/button";

export const SignIn: FC = () => {
  const { api: signInApi, loading } = useApi(signIn);

  const navigate = useNavigate();

  const { values, errors, handleChange, handleSubmit } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required().email(),
      password: Yup.string().required(),
    }),
    onSubmit: async (data) => {
      const result = await signInApi(data);
      if (result) {
        sessionStorage.setItem(
          process.env.REACT_APP_REFRESH_TOKEN as string,
          result.refreshToken,
        );
        sessionStorage.setItem(
          process.env.REACT_APP_TOKEN as string,
          result.token,
        );
        navigate("/app/dashboard");
      }
    },
  });

  return (
    <Grid2
      container
      alignItems="center"
      height="100vh"
      direction="column"
      justifyContent="center"
    >
      <Box width={"45%"}>
        <Grid2
          container
          alignItems="center"
          direction="column"
          justifyContent="center"
        >
          <Avatar sx={{ mb: 1, bgcolor: "secondary.main" }}>
            <LockOutlined />
          </Avatar>
          <Typography component="h1" variant="h5" mb={2}>
            Sign In
          </Typography>
        </Grid2>
        <Box component="form" noValidate mt={1} onSubmit={handleSubmit}>
          <Grid2 container alignItems="center">
            <Grid2 minWidth={100}>
              <Typography variant="subtitle2">Email:</Typography>
            </Grid2>
            <Grid2 flex={1}>
              <TextField
                required
                autoFocus
                fullWidth
                id="email"
                size="small"
                name="email"
                margin="normal"
                autoComplete="email"
                placeholder="john@gmail.com"
                value={values.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={
                  <Typography
                    display="block"
                    textAlign="right"
                    variant="caption"
                  >
                    {errors.email}
                  </Typography>
                }
              />
            </Grid2>
          </Grid2>
          <Grid2 container alignItems="center">
            <Grid2 minWidth={100}>
              <Typography variant="subtitle2">Password:</Typography>
            </Grid2>
            <Grid2 flex={1}>
              <TextField
                required
                fullWidth
                size="small"
                id="password"
                margin="normal"
                name="password"
                placeholder="********"
                type="password"
                autoComplete="current-password"
                value={values.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={
                  <Typography
                    display="block"
                    textAlign="right"
                    variant="caption"
                  >
                    {errors.password}
                  </Typography>
                }
              />
            </Grid2>
          </Grid2>
          <Button
            fullWidth
            type="submit"
            sx={{ mt: 2 }}
            variant="contained"
            loading={loading}
            disabled={loading}
          >
            Enter
          </Button>
        </Box>
      </Box>
    </Grid2>
  );
};
